<template>
  <div class="">
    <div class="layout-header">
      <div class="header-top">
        <div
          class="header-top-left clear-fix"
          style="padding-left:10px;position:relative;border-left: 4px solid #36d5e0;"
        >
          <component
            :is="getComponent(item)"
            :key="item.tenantId"
            v-for="item in conf.listRightItem"
            :conf="item"
            :ref="item.componentCode"
          />
          <div
            v-if="check_result && check_result != '验真通过'"
            class="sign_unable"
          >
            验真未通过
          </div>
          <div v-if="check_result == '验真通过'" class="sign_able">
            验真通过
          </div>
        </div>
        <div class="header-top-right" ref="header_top_right">
          <ButtonGroup>
            <Button v-if="showWithdrawButton" @click="_handleWithdraw"
              >撤回</Button
            >
            <Button
              :key="index"
              v-for="(item, index) in conf.listRightButton"
              @click="_handleClick(item)"
              >{{ item.componentName }}</Button
            >
            <Button
              v-if="conf.dropMenuList && conf.dropMenuList.length"
              @click="_slideTrigger"
              style="position:relative;"
            >
              <span>...</span>
              <Dropdown
                style="position:absolute;top:100%;"
                trigger="custom"
                :visible="slideVisible"
              >
                <DropdownMenu slot="list">
                  <DropdownItem
                    :key="index"
                    v-for="(item, index) in conf.dropMenuList"
                    ><div @click="_handleClick(item)">
                      {{ item.componentName }}
                    </div></DropdownItem
                  >
                </DropdownMenu>
              </Dropdown>
            </Button>
            <!-- <span>
                            <component @_submitBtnEvent = '_onBtnEvent' :is = 'getComponent(item)' :conf = 'item' :key = 'item.tenantId' v-for = '(item,index) in conf.listRightButton' />
                        </span>
                        <span>
                            <Button v-if = 'conf.dropMenuList&&conf.dropMenuList.length' @click = 'slideVisible = !slideVisible' style = 'position:relative;'>
                                <span>...</span>
                                <Dropdown style = 'position:absolute;top:100%;' trigger = 'custom' :visible = 'slideVisible'>
                                    <DropdownMenu slot="list">
                                        <component @_submitBtnEvent = '_onBtnEvent' :is = 'getComponent(item)' :conf = 'item' :isSlide = 'true' v-if = 'conf.dropMenuList.length' :key = 'item.tenantId' v-for = '(item,index) in conf.dropMenuList' />
                                    </DropdownMenu>
                                </Dropdown>
                            </Button>
                        </span> -->
          </ButtonGroup>
          <span style="position:absolute;right:0;bottom:0;">
            <component
              :value="{
                custPhone: $params.mobile_nbr,
                custIdCard: $params.cust_idCard,
                custName: $params.cust_name
              }"
              @customCheckLayoutEvent="_customCheckLayoutEvent"
              v-if="$store.state.dynamicComponent.DIYLAYOUT && hasField"
              v-show="checkPopShow"
              :is="
                $store.state.dynamicComponent.DIYLAYOUT[
                  'ScdrCustomerCheckLayout'
                ]
              "
            />
          </span>
        </div>
      </div>
      <div class="header-field-content clear-fix">
        <template v-for="item in conf.listRightTabsItem">
          <component
            :tit="fieldTitList[item.componentCode] || ''"
            v-if="
              item.componentType != '3' ||
                item.fieldsType == 'groupTitle' ||
                fieldList[item.componentCode]
            "
            style="z-index:99;right:0;"
            :is="getComponent(item)"
            :key="item.tenantId"
            :conf="item"
            :ref="item.componentCode"
            :isTopField = "true"
          />
        </template>
      </div>
    </div>
    <div class="layout-top">
      <component
        :conf="item"
        :key="index"
        :is="getComponent(item)"
        v-for="(item, index) in conf.listRight"
      />
    </div>
    <div style="display:flex;">
      <div style="flex:7;padding-right:10px;overflow:auto;">
        <div class="layout-tab">
          <MyTab
            :fieldTitList="fieldTitList"
            :fieldList="fieldList"
            v-if="conf.tabsList"
            ref="myTab"
            :tab-conf="conf.tabsList"
          />
        </div>
        <div class="layout-bottom">
          <component
            :conf="item"
            :key="index"
            :is="getComponent(item)"
            v-for="(item, index) in conf.listRightGridCol"
          />
        </div>
      </div>
      <div
        style="flex:3;overflow:auto;"
        v-if="conf.tabsStepList"
        v-show="flowTabShow"
      >
        <MyTab
          :fieldTitList="fieldTitList"
          :fieldList="fieldList"
          ref="myTabStep"
          :tab-conf="conf.tabsStepList"
        />
      </div>
    </div>
    <Drawer
      :title="drawerTitle"
      v-model="drawerShow"
      :footer-hide="true"
      :mask-closable="false"
      @on-close="_onDrawerClose"
      className="customDrawerStyle"
      width="500"
      :styles="styles"
    >
      <FormField ref="objectAddOrEdit" v-if = "drawerShow" :data = "drawerParams" @on-success="_submitSuccess" />
      <!-- <objectAddOrEdit
        ref="objectAddOrEdit"
        v-if="drawerShow && hasField && drawerParams"
        style="padding-bottom:55px;"
        :data="drawerParams"
        @on-success="_submitSuccess"
      >
      </objectAddOrEdit> -->
      <div
        class="button-drawer-footer"
        style="position:fixed;width:500px;right:0;bottom:0;left: inherit;"
      >
        <Button type="primary" @click="_handleDrawerSubmit()">保存</Button>
        <Button @click="drawerShow = false" style="margin-left:10px"
          >取消</Button
        >
      </div>
    </Drawer>
    <addObjectData
      v-if="$params"
      :isSccm="isSccm"
      ref="addObjectData"
      :params="$params"
    />
    <shareBtn v-if="($params&&$params.busType)" ref = 'shareLinkBtn' v-show = 'shareBtnShow' :params = "$params" />
    <endFlow ref = "endFlow" />
    <objPrint ref = "objPrint" />
  </div>
</template>
<script> 
import envConst from '@/env-const.js'
import conf from './conf.js'
import getComponent from './getComponent.js'
import MyGrid from './showGrid.vue'
import MyTab from './showTab.vue'
import addObjectData from './addObjectData.vue'
import shareBtn from './shareBtn.vue'
import endFlow from './endFlow.vue'
import objPrint from './obj_print.vue'
import ObField from '@/components/common/questionnaire/index.vue'
import minixBase64enDe from '@/components/common/questionnaire/mdwfCompUtil/minixBase64enDe.js'
export default {
  name: 'scmd-detail',
  data() {
    return {
      showWithdrawButton: false,
      slideVisible: false,
      $params: {},
      conf: {},
      check_result: '', //三要素验真值
      checkPopShow: false,
      flowTabShow: false,
      hasField: false, //已获取字段
      fieldList: {}, //有效字段,
      fieldTitList: {}, //最新的字段标题名
      drawerShow: false,
      drawerTitle: '新增',
      drawerParams: {}, //新增编辑表单组件参数
      isScwf: false, //是否为工单
      isSccm: false, //
      loginUserInfo: {},
      businessesEdit: [],
      businesses: [],
      shareBtnShow: false,//分享组件
      objectName: ''
    }
  },
  destroyed(){
    this.$store.commit('main/layoutStore/clear')
  },
  beforeRouteEnter(to, from, next) {
    console.log('from----------------------', from)
    console.log(location.hash)
    if (from.name) {
      try{
        sessionStorage.setItem('layoutDetailFromRouter', JSON.stringify({
          name: from.name,
          path: from.path,
          query: from.query,
          params: from.params,
          meta: {
            title: from.meta.title?from.meta.title:(from.query?from.query.objectName:'')
          }
        }))
      }catch(e){

      }
    }
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    next()
  },
  activated(){
   
  },
  created() {
    this.createdInit()
  },
  mounted() {
    this.mountedInit()
    this.$eventBus.on('TAB_ROUTE_CHANGE',(route)=>{
      if(route.name === 'scmd-detail'){
        this.createdInit()
        this.mountedInit()
      }
    })
  },
  methods: {
    createdInit(){
      this.$store.commit('main/setPageCatch')
      let userInfo = JSON.parse(window.localStorage.user)
      this.loginUserInfo = userInfo.info
      if(sessionStorage.layoutDetailFromRouter){
        this.$eventBus.emit('_callBreadcrumbs',[JSON.parse(sessionStorage.layoutDetailFromRouter),this.$route])
      }
    },
    mountedInit(){
      const { moId, mtId, busType } = this.$router.currentRoute.query
      this.moId = moId || ''
      this.mtId = mtId || ''
      this.busType = busType || ''
      this._getConf()
      this.checkOrder() //判断是否为工单
      this.getViewsAndBusinessTypeByObjectId()
    },
    //下拉按钮展开折叠
    _slideTrigger() {
      this.slideVisible = !this.slideVisible
      if (this.slideVisible) {
        this.checkPopShow = false
      }
    },
    //打开抽屉 编辑
    _openDrawer(index) {
      if (
        this.loginUserInfo.userType != '1' &&
        this.loginUserInfo.userType != '2'
      ) {
        if (this.businessesEdit.length == 0) {
          this.$Message.warning('无权限操作当前业务类型数据')
          return
        } else {
          let flag = false
          for (let i = 0; i < this.businessesEdit.length; i++) {
            if (this.$params.busType == this.businessesEdit[i].sbtId) {
              flag = true
            }
          }
          if (!flag) {
            this.$Message.warning('无权限操作当前业务类型数据')
            return
          }
        }
      }
      let params = {
        isFlowType: '0',
        tenantId: this.loginUserInfo.tenantId,
        moId: this.$params.moId,
        rowId: this.$params.row_id,
        mtId: this.$params.mtId,
        busType: this.$params.busType,
        modelId: this.$params.flow_model_id,
        businessKey: this.$params.businessKey,
        taskId: ''
      }
      this.drawerTitle = '编辑'
      this.drawerParams = params
      this.drawerShow = true
    },
    //新增按钮事件
    _addBtnEvent() {
      if (
        this.loginUserInfo.userType != '1' &&
        this.loginUserInfo.userType != '2'
      ) {
        if (this.businesses.length == 0) {
          this.$Message.warning('无权限新增当前业务类型数据')
          return
        } else {
          let flag = false
          for (let i = 0; i < this.businesses.length; i++) {
            if (this.$params.busType == this.businesses[i].sbtId) {
              flag = true
            }
          }
          if (!flag) {
            this.$Message.warning('无权限新增当前业务类型数据')
            return
          }
        }
      }

      if (this.isScwf) {
        this.$eventBus.emit('dynamicComponent/call/workOrderCreateGlobal', {
          customerInfo: {
            sourceKey: 'WORK_FROM_XQ', //来源标记
            busType: this.busType //业务类型id
          }
        })
      } else {
        this.$refs['addObjectData'].openDrawer()
      }
    },
    _onDrawerClose() {
      this.drawerParams = null
    },
    //新增、编辑
    _handleDrawerSubmit() {
      this.$refs['objectAddOrEdit'].customSubmit()
    },
    //处理新增、编辑回调
    _submitSuccess(data) {
      console.log(data)
      this._getField()
      this.drawerShow = false
    },
    //处理验真回调
    _customCheckLayoutEvent(data) {
      console.log(data)
      if (data.close) {
        this.checkPopShow = false
      }
      if (data.code) {
        if (data.code == '301') {
          this.check_result = '验真通过'
          this.checkPopShow = false
        } else {
          this.check_result = '验真不通过'
        }
        if (this.$refs['check_result']) {
          this.$refs['check_result'][0].data = this.check_result
        }
      }
    },
    //按钮事件逻辑（撤回）
    _showWithdrawButton() {
      //传入参数  flow_instance_id
      this.$http
        .get(
          envConst.API_BASE_URL +
            '/scmd/models/getFlowPropertys/' +
            this.$params.flow_instance_id
        )
        .then(response => {
          if (response.data.returnCode == '0') {
            if (response.data.bean.canrevoke) {
              this.showWithdrawButton = true
            }
          } else {
            this.$Message.error(response.data.returnMessage)
          }
        })
        .catch(error => {
          console.error('获取节点流程属性信息异常', error)
        })
    },
    _handleWithdraw() {
      this.$Modal.confirm({
        title: '确认撤回',
        content: '确认撤回此流程？',
        onOk: () => {
          this.$http
            .get(envConst.API_BASE_URL + '/scmd/flow/recallFlow', {
              params: {
                processInstanceId: this.$params.flow_instance_id
              }
            })
            .then(response => {
              if (response.data.returnCode == 0) {
                if ((response.data.bean = '1')) {
                  this.$Message.info('撤回成功')
                } else {
                  this.$Message.info(response.data.bean)
                }
              } else {
                this.$Message.error(response.data.returnMessage)
              }
            })
            .catch(error => {
              console.error('撤回操作失败', error)
            })
        },
        onCancel: () => {}
      })
    },
    //删除操作
    _handleDele(conf) {
      this.$http
        .get(`${envConst.API_BASE_URL}/scmd/dynObject/deleteDataByMtId`, {
          params: {
            moId: this.$params.moId,
            mtId: this.$params.mtId
          }
        })
        // this.$http.get(envConst.API_BASE_URL+`/sccm/custom/deleteDataByMtId?moId=${this.$params.moId}&mtId=${this.$params.mtId}`)
        .then(({ data }) => {
          console.log(data)
          if (data.returnCode == '0') {
            if (data.bean.checkCode === true) {
              this.$Message.success('删除成功')
              this._goback()
              // this.$router.back();
              // if (sessionStorage.getItem('layoutDetailFromRouter')) {
              //   this.$router.push({
              //     name: sessionStorage.getItem('layoutDetailFromRouter')
              //   })
              // } else {
              //   this.$router.back()
              // }
              return
            } else {
              this.$Message.error(data.bean.errMsg)
            }
          }else{
			  this.$Message.error(data.returnMessage)
          }
        })
    },
    //处理打开URL按钮
    _handleOpenUrl(conf) {
      let openType = conf.componentParameters == 0 ? '_self' : '_blank'
      window.open(conf.componentUrl, openType)
    },
    //结束流程操作
    _endFlow(){
      console.log(this.$params)
      this.$Modal.confirm({
        title: '确认要结束流程吗',
        content: '结束流程后本条数据将停止流转，你确定要结束流程吗？',
        onOk: () => {
          this.$refs['endFlow'].endFlow(this.$params)
        },
        onCancel: () => {}
      })
    },
    //打印操作
    _print(){
      this.$refs['objPrint'].print(this.conf,this.$params)
    },
    //初始化客户验真操作按钮
    _customerCheckResult(params) {
      console.log(this.$refs['header_top_right'])
      this.$eventBus.emit('dynamicComponent/call/customInfoCheck', {
        customBasicInfo: {
          custName: params.custName,
          custIdCard: '',
          custPhone: params.custPhone
        },
        target: this.$refs['header_top_right']
      })
    },
    //退出操作
    _goback(){
      if (sessionStorage.getItem('layoutDetailFromRouter')) {
        let from = JSON.parse(sessionStorage.getItem('layoutDetailFromRouter'))
        this.$router.push({
          name: from.name,
          query: from.query
        })
      } else {
        this.$router.back()
      }
    },
    //打开分享组件
    _openShareLink(){
      this.$refs['shareLinkBtn']&&this.$refs['shareLinkBtn'].open()
    },
    //初始化按钮-----------------
    _btnInit(params) {
      // this._showWithdrawButton(params);
      // this._customerCheckResult(params);
    },
    _handleClick(item) {
      console.log(item)
      //打开链接
      if (item.componentCode == 'openURL') {
        this._handleOpenUrl(item)
      }
      //返回
      if (item.componentCode == 'backBtn') {
        this._goback();
        // if (sessionStorage.getItem('layoutDetailFromRouter')) {
        //   this.$router.push({
        //     name: sessionStorage.getItem('layoutDetailFromRouter')
        //   })
        // } else {
        //   this.$router.back()
        // }
      }
      //打印
      if (item.componentCode == 'printBtn') {
        // window.print()
        this._print()
    
      }
      //验真
      if (item.componentCode == 'checkBtn') {
        console.log(this.checkPopShow)
        this.checkPopShow = !this.checkPopShow
        if (this.checkPopShow) {
          this.slideVisible = false
        }
      }
      //新增
      if (item.componentCode == 'addBtn') {
        // this._openDrawer(1);
        this._addBtnEvent()
      }
      //编辑
      if (item.componentCode == 'updateBtn') {
        this._openDrawer(1)
      }
      //结束流程
      if(item.componentCode == 'endFlowBtn'){
        this._endFlow()
      }
      //删除
      if (item.componentCode == 'deleteBtn') {
        if (
          this.loginUserInfo.userType != '1' &&
          this.loginUserInfo.userType != '2'
        ) {
          if (this.businessesEdit.length == 0) {
            this.$Message.warning('无权限操作当前业务类型数据')
            return
          } else {
            let flag = false
            for (let i = 0; i < this.businessesEdit.length; i++) {
              if (this.$params.busType == this.businessesEdit[i].sbtId) {
                flag = true
              }
            }
            if (!flag) {
              this.$Message.warning('无权限操作当前业务类型数据')
              return 
            }
          }
        }
        // if(this.$params&&this.$params.flow_instance_id&&this.$params.state_id&&this.$params.state_id!=1){
        //   this.$Message.warning('不是暂存状态，不能删除');
        //   return
        // }
        this.$Modal.confirm({
          title: '确认',
          content: '确认删除此条数据？',
          onOk: () => {
            this._handleDele(item)
          },
          onCancel: () => {}
        })
      }
      if(item.componentCode == 'shareLinkBtn'){
        this._openShareLink()
      }
      this.slideVisible = false
    },
    _getComName(params) {
      this.$eventBus.emit(`dynamicComponent/call/diyLayout`, {
        active: true,
        data: params,
        type: 1
      })
    },
    _getField() {
      // this.$http.get(envConst.API_BASE_URL + `/scmd/fields/getFieldDetailByMtId?moId=${"8cedde2fbdc24062be73f60c5ad5c9ac"}&mtId=${"123456"}`).then(res => {
      this.$http
        .get(
          envConst.API_BASE_URL +
            `/scmd/fields/getFieldDetailByMtIdNew?moId=${this.moId}&mtId=${this.mtId}`
        )
        .then(res => {
          console.log(res)
          let { data } = res
          if (data.returnCode == 0) {
            if(data.beans[0]['encryption']=='1'){
              data.beans[0]['cust_name']?data.beans[0]['cust_name']=minixBase64enDe.base64Enshowbase64De('cust_name',data.beans[0]['cust_name'],1):''
              data.beans[0]['cust_phone']?data.beans[0]['cust_phone']=minixBase64enDe.base64Enshowbase64De('cust_phone',data.beans[0]['cust_phone'],1):''
            }
            this.$store.commit('main/layoutStore/setFieldParams',data.beans[0])
            // this.setAllFieldVal(data.beans[0])
            let params = {
              ...data.beans[0],
              moId: this.moId,
              mtId: this.mtId,
              busType: this.busType,
              objectName: this.objectName
            }
            this.$params = params
            //获取字段信息后初始化打印模板
            this.$refs['objPrint'].initPrint(this.conf,this.$params)
            if (this.$params && this.$params.flow_instance_id) {
              this.flowTabShow = true
            }
            this.hasField = true
            this._btnInit(params)
            this.$nextTick(() => {
              this._getComName(params)
            })
          } else {
            this.$Message.error(data.msgMessage)
          }
        })
    },
    // 获取视图和业务列表
    getViewsAndBusinessTypeByObjectId() {
      this.$http
        .get(
          `${envConst.API_BASE_URL}/scmd/Object/getCustomObjectView?moId=${this.moId}`
        )
        .then(({ data }) => {
          if (data.bean.BusinessTypeList) {
            this.businessesEdit = []
            if (
              this.loginUserInfo.userType != '1' &&
              this.loginUserInfo.userType != '2'
            ) {
              this.businesses = data.bean.BusinessTypeList.filter(item => {
                return item.isNew == 1
              })
              this.businessesEdit = data.bean.BusinessTypeList.filter(item => {
                return item.isOperate == 1
              })
            } else {
              this.businesses = data.bean.BusinessTypeList
            }
          } else {
            this.businesses = []
            this.businessesEdit = []
          }
        })
    },
    _getConf() {
      // this.$http.get(envConst.API_BASE_URL + `/scmd/layout/getLayout?moId=${"8cedde2fbdc24062be73f60c5ad5c9ac"}&busType=${"432cfc9220224a54867532445d8eea4a"}`).then((res)=>{
      this.$http
        .get(
          envConst.API_BASE_URL +
            `/scmd/layout/getLayout?moId=${this.moId}&busType=${this.busType}&usePermission=use`
        )
        .then(res => {
          console.log(res)
          let { data } = res
          if (data.returnCode == 0) {
            if (!data.bean.layoutData) {
              this.$Message.error('布局数据为空!')
              return
            }
            this.$store.commit('main/layoutStore/setColumnNum',parseInt(data.bean.showColumnNum))
            let conf = JSON.parse(data.bean.layoutData)
            // conf.listRightButton = conf.listRightButton.concat(conf.dropMenuList);
            console.log(conf)
            this.conf = conf
            if (data.bean.objectFieldLists) {
              for (let i in data.bean.objectFieldLists) {
                this.fieldList[data.bean.objectFieldLists[i].fieldCname] = true
                this.fieldTitList[data.bean.objectFieldLists[i].fieldCname] =
                  data.bean.objectFieldLists[i].fieldName
              }
            }
            this.$nextTick(() => {
              this._getField()
            })
            console.log(this.conf)
            this._handleButtons(this.conf)
          } else {
            this.$Message.error(data.returnMessage)
          }
          console.log(JSON.parse(data.bean.layoutData))
        })
    },
    _handleButtons(conf){//处理因权限按钮总数少于5的情况
      try{
        let num = conf.listRightButton.length + conf.dropMenuList.length
        if(conf.listRightButton.length<5&&num<=5){
          conf.listRightButton = conf.listRightButton.concat(conf.dropMenuList)
          conf.dropMenuList = []
        }
      }catch(e){

      }
    },
    _diyEvent(params, ctx, utils, script) {
      //自定义按钮事件执行
      eval(script)
    },
    _onBtnEvent(conf) {
      //接收按钮事件
      let fields = {}
      for (let i in this.conf.listRightTabsItem) {
        fields[this.conf.listRightTabsItem[i].componentCode] = this.$refs[
          this.conf.listRightTabsItem[i].componentCode
        ][0].data
      }
      let tabsField = this.$refs['myTab'].getFieldData()
      const params = { ...fields, ...tabsField } //获取所有字段数据

      if (conf.componentType === '0') {
        this._diyEvent(params, this, null, conf.buttonEvent)
        return
      }
    },
    setAllFieldVal(datas) {
      this.check_result = datas.check_result
      for (let i in datas) {
        this.setFieldVal(i, datas[i])
      }
      this.$refs['myTab'] && this.$refs['myTab'].setFieldData(datas)
    },
    setFieldVal(fieldName, val) {
      this.$refs[fieldName] && (this.$refs[fieldName][0].data = val)
    },
    getComponent,
    //判断是否工单流程
    checkOrder() {
      this.$http
        .get(
          envConst.API_BASE_URL +
            `/scmd/Object/getObjectListByBean?moId=${this.moId}`
        )
        .then(({ data }) => {
          console.log(data)
          if (data.returnCode == '0') {
            if (data.beans && data.beans.length) {
              this.objectName = data.beans[0].objectTname
              this.$params = this.$params || {}
              this.$params.objectName = this.objectName
              if (data.beans[0] && data.beans[0].applicationType === 'sccm') {
                this.isSccm = true
              }
              if (data.beans[0] && data.beans[0].applicationType === 'scwf') {
                this.isScwf = true
              }
            }
          }
        })
    }
  },
  props: {},
  components: {
    MyGrid,
    MyTab,
    addObjectData,
    shareBtn,
    endFlow,
    objPrint,
    ObField,
  }
}
</script>
<style scoped  lang="less">
.layout-header {
  padding: 20px;
  border-radius: 3px;
  // border: 1px solid #ccc;
  background: #fff;
  .sign_unable {
    background: rgba(240, 170, 30, 0.1);
    display: inline-block;
    height: 30px;
    padding: 0 10px;
    line-height: 30px;
    color: #f0aa1e;
    border: 1px solid rgba(240, 170, 30, 0.5);
    border-radius: 2px;
  }
  .sign_able {
    background: rgba(4, 203, 216, 0.1);
    display: inline-block;
    height: 30px;
    padding: 0 10px;
    line-height: 30px;
    color: #04cbd8;
    border: 1px solid rgba(4, 203, 216, 0.5);
    border-radius: 2px;
  }
  .header-top {
    padding-bottom: 20px;
    &:after {
      content: '';
      overflow: hidden;
      clear: both;
      display: block;
      height: 0;
      visibility: hidden;
    }
    .header-top-left {
      float: left;
      .scmd_layout-box {
        // width:100%!important;
        .field-dt {
          display: none;
        }
      }
      dd {
        font-size: 16px;
      }
      dl {
        width: 100% !important;
      }
    }
    .header-top-right {
      float: right;
      position: relative;
      .ivu-poptip-popper {
        display: block !important;
      }
    }
  }
  .header-field-content {
    // display: flex;
    display: block !important;
    width: 100%;
    & /deep/ .in-fields{
      width: 20%!important;
    }
    dl {
      display: inline-block;
      
      dt {
        color: #9999a4;
        font-size: 14px;
      }
      dd {
        color: #5e5f77;
        font-size: 16px;
      }
    }
  }
  .clear-fix:after {
    content: '';
    height: 0;
    display: block;
    clear: both;
    overflow: hidden;
    visibility: hidden;
  }
}
</style>